import { Component, TemplateRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { IChangeCallback } from '../../_entities';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
	selector: 'editable-button',
	template: require('./editable-button.template.html')
})
export class EditableButton {
	isDisabled: boolean = false;

	constructor(private modalService: BsModalService) { }

	bsModalRef: BsModalRef;

	@Input("disabled") set disabledBinding(val: boolean) {
		this.isDisabled = val;
	}

	@ViewChild('errorTemplate') errorTemplate;

	@Input() text: string = "";

	@Input() icon: string;

	@Input() tooltiptext: string = "";

	@Input() buttonClass: string = "btn-sm";

	@Output() clickCallback = new EventEmitter<IChangeCallback<any>>();

	watingforResolve: boolean;
	errorMessage: string = "";
	error: any;


	onClick() {
		this.watingforResolve = true;
		this.clickCallback.emit({
			id: "",
			newValue: "",
			oldValue: "",
			resolve: () => {
				this.watingforResolve = false;
			},
			reject: (error: any) => {

				this.watingforResolve = false;
				this.errorMessage = "Could not complete the operation";
				this.error = error;
				this.bsModalRef = this.modalService.show(this.errorTemplate);
			}
		});
	}
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/editable-button.component.ts